export default __webpack_public_path__ + "static/media/shaffler2.4b89905b.png";